import {
  CREATE_CUSTOMER_OPTION,
  DELETE_CUSTOMER_OPTION,
  EDIT_CUSTOMER_OPTION,
  RECEIVE_CUSTOMER_OPTIONS,
  REQUEST_CUSTOMER_OPTION,
} from '@sophocles/entities/CustomerOption/customerOptionActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_CUSTOMER_OPTIONS: // Read
      return state.merge(action.customerOptions);
    case DELETE_CUSTOMER_OPTION: // Delete
      return state.delete(action.customerOption.toString());
    case EDIT_CUSTOMER_OPTION: // Update
    case CREATE_CUSTOMER_OPTION: // Create
    case REQUEST_CUSTOMER_OPTION:
    default:
      return state;
  }
}

export function customerOptionReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_CUSTOMER_OPTION:
    case DELETE_CUSTOMER_OPTION:
    case RECEIVE_CUSTOMER_OPTIONS:
    case EDIT_CUSTOMER_OPTION:
    case REQUEST_CUSTOMER_OPTION:
      return getState(state, action);
    default:
      return state;
  }
}
